import React from 'react';
import { AppSkeletonImage } from '../../common/ui/AppSkeletonImage.tsx';
import skeletonSVG from './assets/version-detail-skeleton.tpl.svg';

export const VersionDetailSkeleton = () => <AppSkeletonImage src={skeletonSVG} />;
